export enum WORKFLOW_TYPE_ENUM {
  GET = 'get',
  DELETE = 'delete',
  RESTRICT = 'restrict',
  UPDATE = 'update',
}
